import styles from "./VerSeccion.module.css";
import { FaArrowLeft, FaMedapps } from 'react-icons/fa';
import AreasProfesionales from '../../../Home/Tutor/tutorcomponentes/AreasProfesionales';
import DirectorioUniversidades from '../../../Home/Tutor/tutorcomponentes/DirectorioUniversidades';
import FeriasUniversitarias from '../../../Home/Tutor/tutorcomponentes/FeriasUniversitarias';
import BecasVigentes from '../../../Home/Tutor/tutorcomponentes/BecasVigentes';
import VideosRecorridos from "../../../Home/Tutor/tutorcomponentes/VideosRecorridos";
import { useEffect, useState } from 'react';
import {useAuth} from '../../../Auth/AuthContext';

const VerSeccion = ({ seccion, onBack }) => {
    const [seccionData, setSeccionData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { getToken } = useAuth(); 
    const token = getToken(); 

    const componentes = {
        AreasProfesionales,
        DirectorioUniversidades,
        FeriasUniversitarias,
        BecasVigentes,
        VideosRecorridos
    };

    useEffect(() => {
        const fetchSeccionDetails = async () => {
            if (!seccion || !seccion.id) {
                setError('No se proporcionó ID de sección');
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/seccion/${seccion.id}`, {
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                    }
                });
                
                if (!response.ok) {
                    throw new Error(`Error ${response.status}: ${response.statusText}`);
                }
                
                const data = await response.json();
                
                if (data && data.length > 0) {
                    setSeccionData(data[0]);
                } else {
                    setError('No se encontraron datos de la sección');
                }
            } catch (error) {
                console.error('Error al cargar la sección:', error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchSeccionDetails();
    }, [seccion, token]);
    
    const manejarVerPDF = (seccionInfo) => {
        if (seccionInfo.se_archivo) {
            const url = `${process.env.REACT_APP_API_URL}/pasos${seccionInfo.se_ruta_archivo}`;
            window.open(url, '_blank');
        } else {
            alert('Archivo no disponible');
        }
    };

    // Componente VideoEmbed igual que en DetalleSeccion
    const VideoEmbed = ({ url, className }) => {
        const getEmbedUrl = (originalUrl) => {
            // Google Drive
            const driveRegex = /(?:https?:\/\/)?(?:www\.)?drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/;
            const driveMatch = originalUrl.match(driveRegex);
            
            if (driveMatch && driveMatch[1]) {
                return `https://drive.google.com/file/d/${driveMatch[1]}/preview`;
            }
            
            // Canva
            const canvaRegex = /(?:https?:\/\/)?(?:www\.)?canva\.com\/design\/([a-zA-Z0-9_-]+)\/([a-zA-Z0-9_-]+)\/watch/;
            const canvaMatch = originalUrl.match(canvaRegex);
            
            if (canvaMatch && canvaMatch[1] && canvaMatch[2]) {
                const designId = canvaMatch[1];
                const viewId = canvaMatch[2];
                return `https://www.canva.com/design/${designId}/${viewId}/view?embed`;
            }
            
            // YouTube
            const youtubeRegex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/;
            const youtubeMatch = originalUrl.match(youtubeRegex);
            
            if (youtubeMatch && youtubeMatch[1]) {
                return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
            }
            
            // Vimeo
            const vimeoRegex = /vimeo\.com\/(\d+)/;
            const vimeoMatch = originalUrl.match(vimeoRegex);
            
            if (vimeoMatch && vimeoMatch[1]) {
                return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
            }
            
            return originalUrl;
        };

        return (
            <iframe
                className={className}
                src={getEmbedUrl(url)}
                allow="autoplay; encrypted-media"
                frameBorder="0"
                allowFullScreen
            />
        );
    };

    // Estados de carga y error
    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loadingContent}>
                    <div className={styles.loadingSpinner}></div>
                    <p className={styles.loadingText}>Cargando sección...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
        <div className={styles.loadingContainer}>
            <div className={styles.loadingContainer}> 
            <p className={styles.loadingText}> Error al cargar sección :( </p>
            </div>
        </div>
        );
    }

    if (!seccionData) {
        return (
            <div className={styles.vistaContainer}>
                <div className={styles.vistaHeader}>
                    <button className={styles.btnSeccionVistaBack} onClick={onBack}>
                        <FaArrowLeft className={styles.flechaSeccionVolver} />
                        Volver al paso
                    </button>
                </div>
                <div className={styles.error}>
                    No se pudo cargar la información de la sección.
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className={styles.vistaContainer}>
                <div className={styles.vistaHeader}>
                    <button className={styles.btnSeccionVistaBack} onClick={onBack}>
                        <FaArrowLeft className={styles.flechaSeccionVolver} />
                        Volver al paso
                    </button>
                    <div className={styles.messageVista}>
                        <FaMedapps className={styles.messageIcon} />
                        Esto es lo que verá el usuario con la información de la sección.
                    </div>
                </div>
                
                <div className={styles.cuerpoContainerSeccion}>
                    <div className={styles.rowContainer}>
                        <div className={styles.rowContainer}>
                            <h2>{seccionData.se_nombre || 'Sin nombre'}</h2>
                        </div>
                    </div>
                    
                    <div className={styles.rowContainer}>
                        <p>{seccionData.se_descripcion || 'Sin descripción disponible'}</p>
                        
                        {/* Renderizado de contenido igual que en DetalleSeccion */}
                        {seccionData.se_tipo_archivo === 'Ejercicio' && (
                            <div className={styles.cardFooter}>
                                <div className={styles.botonesContainer}>
                                    <button 
                                        className={styles.verPdfBtn}
                                        onClick={() => manejarVerPDF(seccionData)}
                                    >
                                        👁️ Ver PDF
                                    </button>
                                </div>
                            </div>
                        )}

                        {seccionData.se_tipo_archivo === 'URL' && (
                            <div>
                                <iframe
                                    className={styles.presentacionUrl}
                                    src={seccionData.se_url}
                                    allowFullScreen
                                    title={`Contenido de ${seccionData.se_nombre}`}
                                />
                            </div>
                        )}

                        {seccionData.se_tipo_archivo === 'Componente' && (
                            <div>
                                {
                                    (() => {
                                        const Componente = componentes[seccionData.se_url];
                                        return Componente ? <Componente /> : <div>Componente no encontrado</div>
                                    })()
                                }
                            </div>
                        )}

                        {seccionData.se_tipo_archivo === 'Video' && (
                            <div>
                                <VideoEmbed 
                                    url={seccionData.se_url} 
                                    className={styles.videoUrl} 
                                />
                            </div>
                        )}

                        {seccionData.se_tipo_archivo === 'PDF' && (
                            <div>
                                <iframe
                                    className={styles.presentacionPdf}
                                    src={`${process.env.REACT_APP_API_URL}${seccionData.se_ruta_archivo}#toolbar=0&navpanes=0&scrollbar=0`}
                                    title={`PDF de ${seccionData.se_nombre}`}
                                />
                            </div>
                        )}
                        
                        <div className={styles.navigationButtons}>
                            <button 
                                className={`${styles.btn} ${styles.btnVolverSeccion}`}
                                onClick={onBack}
                            >
                                Regresar
                            </button>
                            <button className={`${styles.btn} ${styles.btnContinueSeccion} ${styles.disabled}`}>
                                Continuar
                            </button>
                        </div>
                    </div>
                </div>                
            </div>
        </div>
    );
};

export default VerSeccion;